











import { Component, Vue } from 'vue-property-decorator';
import UserForm from '@/components/forms/UserForm.vue';

@Component({
  components: {
    UserForm
  }
})
export default class UserAdd extends Vue {}
